<template class="mt-0 py-0">
	<div>
		<div class="toHide" >
			<v-toolbar text color="white" class="toHide">
				<v-toolbar-title>Preview</v-toolbar-title>
				<v-divider
				class="mx-2"
				inset
				vertical
				></v-divider>
				<v-btn class="primary mr-2" @click.stop="email = true">Email</v-btn>
				<v-btn class="primary mr-2" @click="print">Print</v-btn>
				<v-btn class="primary mr-2 d-none d-sm-block" @click="createPdf(present)">Present</v-btn>
				<v-spacer></v-spacer>

			</v-toolbar>
			<v-divider></v-divider>

			<v-container fluid>
				<v-row justify="center">
					<v-col cols="12">
						<v-row align="center">
							<v-overlay
							:absolute="absolute"
							:opacity="opacity"
							:value="overlay"
							:z-index="zIndex"
							>
							<v-img
							:src="form.image"
							style="height:100vh; width:100vw;"
							contain
							class="grey darken-4 my-12"
							@click="closeOverlay"
							>
						</v-img>
					</v-overlay>
				</v-row>
			</v-col>
		</v-row>
	</v-container>

	<template>
		<v-dialog
		v-model="email"
		max-width="390"
		>
		<v-card>
			<v-form
			ref="form"
			v-model="valid"
			lazy-validation
			>
			<v-card-title dark class="headline">Send As Email</v-card-title>
			<v-card-text>
				<!-- <p class="">Message:</p> -->
				<v-text-field
				class="mt-5"
				name="recipientEmail"
				v-model="form.recipientEmail"
				label="Email To: "
				:rules="[rules.required, rules.email]"
				required="true"
				outlined
				></v-text-field>
				<v-textarea class="body-2" outlined counter="500" text-capitalize v-model="message" maxlength="500" label="Email Message"></v-textarea>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" type="submit" @click.prevent="createPdf(sendEmail)" :disabled="!valid" :loading="loading">Send</v-btn>
			</v-card-actions>
		</v-form>
	</v-card>
</v-dialog>
</template>
</div>


<div class="mt-0 py-0" id="print">
	<v-container class="mt-0 py-0">
		<v-row>
			<v-col class="py-0">
				<header id="header">
					<img class="invoiceNames" src="../assets/namesInvoice.png" alt="">
					<img height="140" class="logo" id="logo" :src="$store.state.company.imageUrl" alt="">
					<p class="cname text-capitalize">{{ preview.customerName }} </p>
					<p class="tname text-capitalize">{{ preview.techName }} </p> 
					<p class="invoice text-capitalize">{{ preview.invoiceNum }} </p>
					<p class="date text-capitalize">{{ dateNow }} </p>
				</header>
			</v-col>
		</v-row>

		<!-- Summary Section -->
		<v-row light v-if="summarySection">
			<v-col class="py-0">
				<h4 class="text-left mb-3 mt-1 recommendations"><u>Recommendations/Diagnostics/Summary</u></h4>
				<!-- dividers here -->
				<p class="underline"></p>
				<p class="underline"></p>
				<p class="underline"></p>
				<p class="underline"></p>
				<p class="underline"></p>
				<p class="underline"></p>
				<p class="underline"></p>
				<p class="underline"></p>
			</v-col>
		</v-row>

		<v-row>
			<v-col class="py-0">
				<h5 class="mt-0 mb-3" id="solutions"><u>Solutions:</u>
					<h6 v-if="option[1].isCap || option[2].isCap || option[3].isCap || option[4].isCap || option[5].isCap || option[6].isCap" class="caption text-right pr-4">** Includes Comfort Assurance Plan Membership Discount</h6>
					<h6 v-if="selectedDiscount" class="caption text-right pr-4">{{ selectedDiscount.description }}</h6>
					<h6 class="caption text-right pr-4">{{ $store.state.company.priceDisclosure }}</h6>
					<h6 v-show="selectedDiscount.amount == 0" v-if="option[1].discount > 0 || option[2].discount > 0 || option[3].discount > 0 || option[4].discount > 0 || option[5].discount > 0 || option[6].discount > 0" class="caption text-right pr-4">** Discounts Applied</h6>
				</h5>
			</v-col>
		</v-row>

		<!-- options -->
		<table class="tableOptions">
    <!-- <thead><tr><td>
      <div class="header-space">&nbsp;</div>
  </td></tr></thead> -->
  <tbody>
  	<!-- <tr><td> -->

  		<tr class="list-group shade" v-for="(s, i) in Object.keys(option).length" :key="i" v-if="option[s].itemsList.length != 0">
  			<td class="list-group-item w-100 mx-0 shade py-1" >      


  				<v-row>
  					<v-col cols="10" class="py-1">
  						<h6 class="ml-1 mt-0 options pb-1" :class="{ alternative: alternative }">{{!alternative ? "Option #" + s + ")" : `- ${alternatives[i]} -`}} <span v-if="option[s].sum > 0 && warranty" class="d-none d-sm-inline-block d-print-inline-block warranty">{{option[s].warranty}}</span></h6>
  						<ul class="descriptionList">
  							<li class="myfont" v-for="(i, ind) in option[s].itemsList" :key="ind">
  								<span class="text-capitalize description">+ {{i.description}}</span>
  							</li>
  						</ul>
  					</v-col>

  					<v-col cols="2" 
  					v-if="option[s].sum <= 1000 || !preview.financing"
  					class="text-right mt-1 mb-0 pl-0 py-0">

  					<v-img max-width="200" max-height="135" v-if="option[s].image !== undefined" class="p-0 m-0 mb-2" :src="option[s].image.imageUrl" contain></v-img>

  					<p v-if="option[s].discount > 0" class="mbNone pricing"> {{ option[s].total }} </p>
  					<p v-if="option[s].discount > 0" class="mbNone pricing">** <u> - {{ option[s].discount }} </u></p>
  					<p class="pricing mbNone">Investment ( {{ option[s].sum }} )</p>
  				</v-col>
  				<!-- Financing -->
  				<v-col cols="2" 
  				v-if="option[s].sum >= 1000 && preview.financing"
  				class="text-right mt-1 mb-0 pl-0 py-0">

  				<v-img max-width="200" max-height="135" v-if="option[s].image !== undefined" class="p-0 m-0 mb-2" :src="option[s].image.imageUrl" contain></v-img>

  				<p class="pricing mb-0">Investment </p>
  				<p class="pricing">{{ option[s].financeMonthlyPayment }} /  Month - {{option[s].financeAmount}}</p>
  			</v-col>
  			<v-row>
  			</v-row>
  		</v-row>

<!--   </td>
</tr>
-->
</td></tr></tbody>
<tfoot><tr><td>
	<div class="footer-space">&nbsp;</div>
</td></tr></tfoot>
</table>

<footer id="footer" class="footer">
	<h2 class="headline font-weight-light font-italic text-xs-center"><i>{{company.footer | capitalize }}</i></h2>
	<h5 class="subtitle-1 font-weight-light font-italic text-xs-center" >{{company.companyPhone}} / {{company.companyWebsite}}</h5>
</footer>
<!-- </v-footer> -->

</v-container>
</div>
<!-- container-fluid end print section-->

</div>
</template>

<script>
import html2canvas from 'html2canvas'
import firebase from '@/helpers/firebaseConfig'

const functions = firebase.functions()

export default {
	name: 'Preview',
	data() {
		return {
			image: true,
			clicked: 0,
			absolute: false,
			opacity: 0.46,
			overlay: false,
			zIndex: 35,
			valid: true,
			loading: false,
			email: false,
			alternatives: ['BEST', 'BETTER', 'GOOD', 'BASIC', 'Option 5', 'Option 6'],
			selectedDiscount2: {"amount":"0","name":"None","description":""},
			form: {
				recipientEmail: '',
				image: null
			},
			rules: {
				required: (value) => !!value || 'Required.',
				email: (value) => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					return pattern.test(value) || 'Invalid e-mail.'
				}
			}
		}
	},
	computed: {
		message: {
			set(message){
				this.$store.commit('emailMessage', message)
			},
			get(){
				return this.$store.state.company.emailMessage
			}
		},
		company(){
			return this.$store.getters.company
		},
		companyName(){
			return this.$store.getters.company.companyName
		},
		option(){
			return JSON.parse(JSON.stringify(this.$store.state.preview.option))
		},
		preview(){
			return this.$store.state.preview
		},
		dateNow(){
			return new Date(this.$store.state.preview.dateNow).toDateString().slice(4)
		},
		selectedDiscount(){
			return this.$store.state.preview.selectedDiscount || this.selectedDiscount2
		},
		warranty(){
			if (this.$store.state.preview.warranty == undefined){
				return true
			} else {
				return this.$store.state.preview.warranty
			}
		},
		summarySection(){
			if (this.$store.state.preview.summarySection == undefined){
				return true
			} else {
				return this.$store.state.preview.summarySection
			}
		},
		alternative(){
			if (this.$store.state.preview.alternative == undefined){
				return false
			} else {
				return this.$store.state.preview.alternative
			}			
		}

	},
	created() {
	// console.log('preview dateNow', this.$store.state.preview.dateNow)
},
methods: {
	closeOverlay(){
		this.clicked += 1
		if (this.clicked >= 4){
			this.overlay = false
			this.clicked = 0
		}

	},
	print () {
		this.$store.commit('drawerMenu', false)
		setTimeout(()=> window.print(), 100)
	},
	createPdf(action){
		this.loading = true
		window.html2canvas = html2canvas
		const el = document.querySelector("#print")
		html2canvas(el).then(canvas => {
			let image = canvas.toDataURL("image/png")
			this.form.image = image
		})
		.then(()=>{
			action()
		})
		.catch(error=> {
			this.loading = false
			this.$store.commit('setSnack', error)
		})
	},
	present(){
		this.loading = false
		this.overlay = true
		this.$store.commit('setSnack', 'Tap 4 Times To Exit Present Mode')
	},
	sendEmail(){
		this.loading = true
		const sendEmail = functions.httpsCallable('sendEmail')
		sendEmail(
			{...this.form,
				name: this.$store.getters.techName,
				companyName: this.$store.state.company.companyName,
				subject: `${this.$store.state.company.companyName} Recommendations`,
				message: this.$store.state.company.emailMessage,
			})
		.then(res => {
			// console.log(res)
			this.loading = false
			this.$store.commit('setSnack', 'Email Was Sent Successfully!')
			this.email = false
		})
		.catch(err => {
			console.log(err)
			this.loading = false
			this.$store.commit('setSnack', 'There Was A Problem Sending The Email')
			this.email = false
		})
	}
},

}
</script>

<style lang="css" scoped>

span.warranty {
	padding: 0px 15px 0px 15px;
	font-size: .8em;
	float: right;
	border: 1px solid #666;
	border-radius: 60%;
	color: #666;
}
footer {
	background: #fff;
}
body, html {
	height: 100%;
	overflow: hidden;
}
h6.alternative {
	font-size: 22px;
}
.clone {
	color: #eee;
	box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
	background-color: #f5f5f5;
	padding: 0 16px;
	display: inline-flex;
	height: 36px;
	border-radius: 2px;
	justify-content: center;
	flex: 0 0 auto;
	font-size: 14px;
	font-weight: 500;
	min-width: 88px;
	outline: 0;
	text-transform: uppercase !important;
	text-decoration: none;
	vertical-align: middle;
}
.clone:hover {
	cursor: pointer;
}  
.names {
	position: absolute; 
	left: 80px; 
	bottom: 5px;
}
.relative {
	position: relative;
}
#footer {
	position: absolute;
	/*position: relative;*/
	text-align: center;
	padding: 0;
	margin: 0 auto;
	bottom: 0;
	width: 100%;
	background-color: #fff;
	height: 70px;
}
#print {
	min-height: 11.29in !important;
	/*height: 11in;*/
	/*width: 8.5in;*/
	width: 9in;
	position: relative;
	top: 0;
	/*size: letter portrait;*/
	background-color: #fff;
	margin: 0 auto;
}


ul {
	list-style-type: none;
}
.activated, button.hover:hover, button.hover:active {
	background: black;
	border: 1px solid;
}
li span {
	font-weight: 600;
	font-size: 1em;
}
li.myfont {
	font-weight: 600;
	margin-right: 0;
	/*margin-left: 5px;*/
	text-transform: capitalize;
	color: #333;
	display: block;

}
p.underline {
	border-bottom: 1px solid #000;
	margin-bottom: 16px;
	width: 100%;
	line-height: 1;
}
#header {
	position: relative;
	width: 100%;
}
.list-group {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	padding-left: 0;
	margin-bottom: 0;
	max-width: 8.7in !important;
}

.list-group-item {
	position: relative;
	display: block;
	padding: .75rem 1.25rem;
	margin-bottom: -1px;
	/*background-color: #fff;*/
	border: 1px solid rgba(0, 0, 0, .125)
}
.list-group-item:first-child {
	border-top-left-radius: .25rem;
	border-top-right-radius: .25rem
}

.list-group-item:last-child {
	margin-bottom: 0;
	border-bottom-right-radius: .25rem;
	border-bottom-left-radius: .25rem
}
p.mbNone {
	margin-bottom: 0;
}
img.logo {
	margin-top: 10px;
	position: absolute;
	top: 0;
	left: 0;
	width: 34%;
	max-width: 100%;
	max-height: 100%;
}
.invoiceNames {
	height: 150px;
	width: 100%;
	top: 0;
	left: 0;
	z-index: 0;
	margin-top: 0;
	padding-top: 0;
	color: #666;
}
.cname, .tname, .invoice, .date {
	position: absolute;
	margin: 0;
	padding: 0;
	font-size: 1rem;
	z-index: 1;
	line-height: 0;
}
.cname {
	left: 47%;
	top: 43%;

}
.tname {
	left: 47%;
	top: 76%;
}
.invoice {
	left: 84%;
	top: 43%;
}
.date {
	left: 81%;
	top: 75%;
}
.black {
	color: black;
}
.shade:nth-child(even){
	/*background-color: #eee;*/
}
#optionContainer{
	padding-bottom: 0px;
}

/* summary/diagnostics header */
h4.recommendations {
	font-size: 1em;
	color: #666;
	margin-top: 25px;
}
/* solutions header*/
h5#solutions {
	font-size: 1em;
	color: #666;
}
/*option # heading*/
h6.options{
	font-weight: bolder;
	font-size: .9em;
	/*color: #aaa;*/
}
/*description text*/
li span {
	font-size: .8em;
}
ul.descriptionList li {
	line-height: 1 !important;
}
/*investment price*/
.pricing {
	font-size: .8em;
	/*text-align: right;*/
}
.list-group-item {
	border: 1px solid rgba(0, 0, 0, .325)
}
.text-muted {
	color: #6c757d !important;
}
.tableOptions {
	margin: 0 auto;
	width: 100%;
}
.header {
	position: fixed;
	top: 0;
}
.header, .header-space {
	height: 70px;
}
#footer, .footer-space {
	height: 70px;
}
.hide {
	display: none;
}
@media screen and (min-width: 1000px) {
	/*h6.options, li span, .pricing {
		font-size: .9em;
	}*/
	#footer, #footer h2, #footer h5{
		/*font-size: 1em;*/
	}
}

@media print {
	* {
		color: #000 !important;
		/*border: 1px solid red !important;*/
	}
	@page {
		margin: 0mm 2mm 0mm 2mm;
		padding: 0mm 0mm 0mm 0mm;
		size: letter portrait;
		/*max-height: 100%;*/
		/*max-width: 100%;*/
		/*height: 11in;*/
		/*width: 8.5in;*/
	}
	.toHide {
		position: absolute;
		z-index: -2;
		display: none;
	}
	#print {
		/*min-height: 11.29in;*/
		/*min-height: 11.27in !important;*/
		top: 0;
		top: 0;
		left: 0;
	}

	/* #footer {
		position: absolute;
		z-index: 0;
		opacity: .9;
		bottom: 0;
		left: 0;
		right: 0;
		margin: 0 auto;
		margin-bottom: 0px;
		padding-bottom: 0px;
		text-align: center;
	}*/
	#footer h2 {
		text-align: center;
		margin: 0 auto;
	}
	#footer h5 {
		text-align: center;
		margin: 0 auto;
	}
	#footer{

		/*position: absolute;*/
		/*position: relative;*/

		/*position: fixed;*/
		/*margin-bottom: 7mm;*/
	}
	.cname, .tname, .invoice, .date {
		font-size: 16px;
	}
	img.logo {
		margin-top: 10px;
		position: absolute;
		top: 0;
		left: 0;
		width: 35%;
		max-width: 100%;
		max-height: 100%;
	}
	/* summary/diagnostics header */
	h4.recommendations {
		font-size: 16px;
		color: #666;
		margin-top: 25px;
	}
	.list-group {
		max-width: 8.7in !important;
	}
	/* solutions header*/
	h5#solutions {
		font-size: 14px;
		color: #666;
	}
	/*option # heading*/
	h6.options{
		font-size: 16px;
		font-weight: bolder;
		color: #666;
	}
	/*description text*/
	li span {
		font-size: 12px;
		color: #555;
	}
	span.warranty {
		font-size: 12px;
		display: inline-block;
		color: #666 !important;
		padding: 0px 6px 0px 6px;

	}
	ul.descriptionList li {
		line-height: .9 !important;
	}
	/*investment price*/
	.pricing {
		font-size: 12px;
		color: #666;
	}
	.shade:nth-child(even) {
		background: #fff;
	}
	.text-muted {
		color: #6c757d !important;
	}

}


.activated, button.hover:hover, button.hover:active {
	color: black;
	border: 2px solid;
}
h1,
h2 {
	font-weight: normal;
}

/*h6.options {
	font-size: 1.1em;
	font-weight: bolder;
	color: black;
}*/
ul {
	list-style-type: none;
	padding: 0;
}
li {
	display: inline-block;
	margin: 0 10px;
}
a {
	color: #42b983;
}
button.animated {
	margin-bottom: 3px;
	-webkit-appearance: button;
	-webkit-writing-mode: horizontal-tb !important;
	text-rendering: auto;
	letter-spacing: normal;
	word-spacing: normal;
	text-transform: none;
	text-indent: 0px;
	text-shadow: none;
	display: inline-block;
	text-align: center;
	cursor: default;
	box-sizing: border-box;
	margin: .5em;
	padding: .5em;
	border-width: 1px;
	border-style: solid;
	border-image: initial;
	border-width: 1px;
	border-color: rgb(216, 216, 216) rgb(209, 209, 209) rgb(186, 186, 186);
	border-image: initial;
	text-transform: capitalize;

}
button:hover {
	/*background-color: blue !important;*/
}

.block {
	display: block;
}
.recommendations {
	font-size: 2vw;
}

.text-capitalize {
	text-transform: capitalize !important;
}

* {
	/*border: 1px solid red !important;*/
}
</style>
